
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confidential-computing",
      function () {
        return require("private-next-pages/confidential-computing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confidential-computing"])
      });
    }
  